module.exports = __webpack_public_path__ + "static/media/16.e6eeeeb0.jpg";